export default __webpack_public_path__ + "static/media/Background-Portal-Mobile.f4b57d2b.jpg";